// src/components/buyer-sales-list/hooks/use-order-list.ts
import useSWR from "swr";
import { OrderApi } from "../../../apis";
import { IOrderFilters } from "../types";

export const useOrderList = (filters: IOrderFilters, enabled = true) => {
  const { data, isLoading, error, mutate } = useSWR(
    enabled ? ["buyer-orders", filters] : null,
    async () => {
      const res = await OrderApi.list({
        filter: {
          type: "",
          orderStatus: filters.orderStatus || "",
          deliveryNoteStatus: filters.deliveryNoteStatus || "",
          businessId: filters.businessId || "",
          startDate: filters.startDate || "",
          endDate: filters.endDate || "",
          invoiceStatus: filters.invoiceStatus || "",
          paymentStatus: filters.paymentStatus || "",
          paymentTermCondition: filters.paymentTermCondition || "",
          excel: "false",
        },
        offset: {
          limit: filters.limit,
          page: filters.page,
        },
      });
      return res;
    },
    { revalidateOnFocus: false }
  );

  return {
    orders: data?.rows || [],
    total: data?.count || 0,
    isLoading,
    error,
    refresh: mutate,
  };
};
